module.exports = {
	L : 1,
	M : 0,
	Q : 3,
	H : 2
};




//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/qr.js/lib/ErrorCorrectLevel.js
// module id = PTy5
// module chunks = 0